import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ISettings } from '@api/types'
import { SettingsFragment } from '@api/fragments'

function _fetch(): Promise<ISettings> {
  return client.gql
    .query({
      query: settingsQuery,
    })
    .then(
      ({
        data: {
          viewer: {
            company: { settings },
          },
        },
      }: {
        data: { viewer: { company: { settings: ISettings } } }
      }) => settings
    )
}

function update(
  newSettings: Partial<{
    [key in keyof ISettings]: any
  }>
): Promise<ISettings> {
  return client.gql
    .mutate({
      mutation,
      variables: {
        input: { ...newSettings },
      },
    })
    .then(({ data: { updateCompanySettings } }: any) => updateCompanySettings)
}

export const settingsQuery = gql`
  query fetchSettings {
    viewer {
      company {
        settings {
          ...SettingsFragment
        }
      }
    }
  }
  ${SettingsFragment}
`
const mutation = gql`
  mutation _($input: UpdateCompanySettingsInput!) {
    updateCompanySettings(input: $input) {
      employeeImportNotificationEnabled
      hotelingDeskDeptEnforcementEnabled
      overrideBookingRestrictionEnabled
      enforceAuthAppEnabled
      unallocateSpaceOnUnseat
      hotelingBookingOverlapRestrictionEnabled
      hotelingDeskWpgEnforcementEnabled
      hotelingDeskWpgEnforcementOperator
      enablePolling
      spaceAvailabilityEnabled
      bookingAutoReleaseEnabled
      bookingCheckInRequired
      hourlyBookingEnabled
      dailyBookingEnabled
      ccEmails
      bookingWorkdayTimeFrom
      bookingWorkdayTimeTo
      enableHealthScreening
      healthScreeningMessage
      healthScreeningConfirmButtonText
      hoursAdminsGetHealthNoticeAfterEmployees
      hoursHealthMessageSentBeforeBooking
      enableBookingCapacityCap
      companyBookingCapacityCap
      enableLocationBookingCapacityCap
      viewPeerCurrentBookings
      showOtherBookers
      enableRecurringBookings
      healthNoticeEnabled
      bookingCheckInCancelEnabled
      hoursBeforeBookingCheckin
      employeeImportApprovalEnabled
      employeeImportApprovalThresholdPercent
      bookableSpaceTypes
      bookableSpaceTypesLocationsOverridesEnabled
      qrCodeEnabled
      bookingReminderEnabled
      bookingConfirmationEnabled
      bookingCancellationEnabled
      healthScreeningConfirmButtonText
      healthScreeningMessage
      bookingNotesEnabled
      overrideSpaceTypeBookingRestrictionEnabled
      overriddenBookingRestrictionSpaceTypes
    }
  }
`
export default { fetch: _fetch, update }
